import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=b24f3e8e&scoped=true"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=js"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=b24f3e8e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24f3e8e",
  null
  
)

export default component.exports